export default __webpack_public_path__ + "static/media/going-bn.78fd70a6.png";